module.exports = __webpack_public_path__ + "static/media/crushed-food.7f2bfa68.jpg";